/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LedgerBoardPrize } from './LedgerBoardPrize';
import {
    LedgerBoardPrizeFromJSON,
    LedgerBoardPrizeFromJSONTyped,
    LedgerBoardPrizeToJSON,
    LedgerBoardPrizeToJSONTyped,
} from './LedgerBoardPrize';

/**
 * 
 * @export
 * @interface LedgerBoardPrizeTier
 */
export interface LedgerBoardPrizeTier {
    /**
     * 
     * @type {number}
     * @memberof LedgerBoardPrizeTier
     */
    rankStart: number;
    /**
     * 
     * @type {number}
     * @memberof LedgerBoardPrizeTier
     */
    rankEnd: number;
    /**
     * 
     * @type {Array<LedgerBoardPrize>}
     * @memberof LedgerBoardPrizeTier
     */
    prizes: Array<LedgerBoardPrize>;
}

/**
 * Check if a given object implements the LedgerBoardPrizeTier interface.
 */
export function instanceOfLedgerBoardPrizeTier(value: object): value is LedgerBoardPrizeTier {
    if (!('rankStart' in value) || value['rankStart'] === undefined) return false;
    if (!('rankEnd' in value) || value['rankEnd'] === undefined) return false;
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    return true;
}

export function LedgerBoardPrizeTierFromJSON(json: any): LedgerBoardPrizeTier {
    return LedgerBoardPrizeTierFromJSONTyped(json, false);
}

export function LedgerBoardPrizeTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerBoardPrizeTier {
    if (json == null) {
        return json;
    }
    return {
        
        'rankStart': json['rankStart'],
        'rankEnd': json['rankEnd'],
        'prizes': ((json['prizes'] as Array<any>).map(LedgerBoardPrizeFromJSON)),
    };
}

export function LedgerBoardPrizeTierToJSON(json: any): LedgerBoardPrizeTier {
    return LedgerBoardPrizeTierToJSONTyped(json, false);
}

export function LedgerBoardPrizeTierToJSONTyped(value?: LedgerBoardPrizeTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rankStart': value['rankStart'],
        'rankEnd': value['rankEnd'],
        'prizes': ((value['prizes'] as Array<any>).map(LedgerBoardPrizeToJSON)),
    };
}

